import API_URLS from "constants/apis.url";

import { deleteRequest, getRequest, postRequest, putRequest } from "./api";

const isAdminAPI = true;

export const getUsers = () => getRequest(API_URLS.adminUsersURL, false);

export const addUser = async user => await postRequest(`${API_URLS.adminUsersURL}`, user, isAdminAPI);

export const editUser = async userData => {
  const { UserId, ...payload } = userData;
  return await putRequest(`${API_URLS.adminUsersURL}/${UserId}`, payload, isAdminAPI);
};

export const deleteUser = async data => {
  const { UserId, ...payload } = data;
  await deleteRequest(`${API_URLS.adminUsersURL}/${UserId}`, payload, isAdminAPI);
};

export const getUserDetails = () => getRequest(API_URLS.userDetailsURL, false);

export const getRole = () => getRequest(`${API_URLS.roleURL}`, false);
export const getSystems = () => getRequest(`${API_URLS.systemsNameURL}`, false);
